"use client"

import AIBenefitsSection from "../AIImplementation/AIBenefitsSection/AIBenefitsSection";
import AICTASection from "../AIImplementation/AICTASection/AICTASection";
import AIHeroSection from "../AIImplementation/AIHeroSection/AIHeroSection";
import AIImpactSection from "../AIImplementation/AIImpactSection/AIImpactSection";
import AIResultsSection from "../AIImplementation/AIResultsSection/AIResultsSection";
import ManufacturingSection from "../AIImplementation/ManufacturingSection/ManufacturingSection";
import OdooChooseSection from "../AIImplementation/OdooChooseSection/OdooChooseSection";

const AIServiceLayout = ({ data }) => {
  return (
    <>
     <AIHeroSection hero={data.hero} />
      <AIImpactSection impact={data.impact} />
      <AIResultsSection result={data.result} />
      <ManufacturingSection manufacturing={data.manufacturing} />
      <AIBenefitsSection benefits={data.benefits} />
      <OdooChooseSection odooChoose={data.odooChoose} />
      <AICTASection cta={data.cta} />
 
    </>
  )
}

export default AIServiceLayout;